//creazione del layer per l'aggiunta layer
import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import  DrawerAddLayer from './DrawerAddLayerButton'
import AddLayerComponent from './AddLayerComponent'

function DrawerLeft(props) {

    const [open, setOpen] = React.useState(false);

    const handleDrawerClose = () => {
        setOpen(false);
    
    
    };

    return (
        <div className={"root"}>
            <DrawerAddLayer openMenu={setOpen} button= {props.value.buttonStyle}/>
            <Drawer
                transitionDuration={500}
                className={"drawer"}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: "drawerPaper",
                    }}
            >       
            <AddLayerComponent callback={handleDrawerClose.bind(this)} />   
            </Drawer>
        </div>
    );
}

export default (DrawerLeft)